module.exports = require("././angular-cookies.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-cookies (bower component)
 ** module id = 156
 ** module chunks = 0
 **/